import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/recommendation/base';
import type { RecommendationProfile } from '@/models/recommendation';

export const useRecommendationProfile = () => {
  const result = useQuery<RecommendationProfile>({
    queryKey: [clientKeys.useRecommendationProfile],
    queryFn: async () =>
      await falconClient.post(`${baseUrl}/profiles`, { profile: {} }),
  });

  return { profile: result.data, ...result };
};

export const useUpdateRecommendationProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (profile: Partial<RecommendationProfile>) => {
      return falconClient.patch(`${baseUrl}/profiles/${profile.id}`, {
        profile,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [clientKeys.useRecommendationProfile],
      });
    },
  });
};

export const useCompleteRecommendationProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (profile: Partial<RecommendationProfile>) => {
      return falconClient.post(`${baseUrl}/profiles/${profile.id}/complete`, {
        profile,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [clientKeys.useRecommendationProfile],
      });
    },
  });
};
